import { Wrapper, Bar } from './styled';
import loadable from '@loadable/component';
import useUser from '@/hooks/useUser';
import { useUserPlans } from '@/hooks/useUserPlans';
import { useUserAccess } from '@/hooks/useUserAccess';
import { formatDistanceToNow } from 'date-fns';
import { useHasMobileTopbarMessage } from '@/hooks/useHasMobileTopbarMessage';
import { useFlag } from '@/features/unleash';

const TrialAnnouncement = loadable(() => import('../TrialAnnouncement'), {
  resolveComponent: (component) => component.TrialAnnouncement,
  ssr: false,
});

const AnnouncementBar = () => {
  const { data: userData } = useUser();
  const { data: userAccess } = useUserAccess();
  const hasAnnouncement = useHasMobileTopbarMessage();
  const { status, type: planType } = useUserPlans();
  const isTrialing = userData.billing.status === 'trialing';
  const flag = useFlag({ name: 'mono-remove-trial' });
  const shouldShowTrialNotification =
    // Non-trial users see the notification
    !isTrialing ||
    // Flags disabled shows the notification
    (flag.flagsReady && !flag.enabled) ||
    // Flag enabled and variant don't show notification
    (flag.flagsReady && flag.enabled && flag.variant.name === 'control');

  if (status !== 'success') {
    return null;
  }

  if (!hasAnnouncement) {
    return null;
  }

  return (
    <Wrapper>
      <Bar>
        {shouldShowTrialNotification && (
          <TrialAnnouncement
            isTrialing={isTrialing}
            planType={planType}
            maxViewCompanyReports={userAccess.viewCompanyReports}
            daysUntilTrialEnds={formatDistanceToNow(
              userData.billing.trialEnd || 0
            )}
          />
        )}
      </Bar>
    </Wrapper>
  );
};

export default AnnouncementBar;
